import React, { lazy } from 'react';
import Left from './Left';
import Right from './Right';
import Mid from './Mid';
import TrustPilot from './TrustPilot';
import BlockSpecified from './BlockSpecified';
import * as styles from './styles.scss';

const Menu = lazy(() => import(/* webpackChunkName: "menu" */ './Menu'));

const Header = ({ search }) => (
    <>
        <BlockSpecified />
        <TrustPilot />
        <header>
            <div className={styles.header}>
                <Left />
                <Mid search={search} />
                <Right />
            </div>
            <Menu />
        </header>
    </>
);

const HeaderCheckout  = () => (
    <header>
        <div className={styles.header}>
            <Left />
        </div>
    </header>
);

export { HeaderCheckout };

export default Header;
